import * as types from "../Actions/Types";
import { IBookmark } from "../Models/Models";

export interface IBookmarkReducerState {
  allBookmarks: IBookmark[];
  activeBookmark: IBookmark;
  loadingBookmarks: boolean;
  foundBookmarks: boolean;
  showBookmarkModal: boolean;
}

const defaultState: IBookmarkReducerState = {
    allBookmarks: null,
    activeBookmark: null,
    loadingBookmarks: true,
    foundBookmarks: true,
    showBookmarkModal: false,
};

export const bookmarks = (
    state: IBookmarkReducerState = { ...defaultState },
    action
): IBookmarkReducerState => {
    switch (action.type) {
        case types.LOAD_BOOKMARKS_SUCCESS: {
            //Get only non-null bookmarks
            //Had to add this because it was returning a null element after deleting a bookmark, even after a fresh load from DB
            const newBookmarks: IBookmark[] = action.data;
            const nonNullBookmarks = newBookmarks.filter((bookmark) => {
                return bookmark;
            });

            return {
                ...state,
                allBookmarks: nonNullBookmarks,
            };
        }

        case types.DELETE_BOOKMARK_SUCCESS: {
            const bookmarksCopy: Array<IBookmark> = [...state.allBookmarks];
            for (let i = 0; i < bookmarksCopy.length; i++) {
                if (bookmarksCopy[i].id === action.data.id) {
                    bookmarksCopy.splice(i, 1);
                    break;
                }
            }

            return {
                ...state,
                allBookmarks: bookmarksCopy,
            };
        }

        case types.SET_DEFAULT_BOOKMARK_SUCCESS: {
            const bookmarksCopy: Array<IBookmark> = [...state.allBookmarks];
            // reset all
            bookmarksCopy.forEach((bookmark: IBookmark) => {
                bookmark.isDefault = false;
            });
            // find the updated one
            const updatedBookmark: IBookmark = bookmarksCopy.find(
                (bookmark: IBookmark) => {
                    return bookmark.id === action.data.id;
                }
            );
            // set it to default
            if (updatedBookmark) {
                updatedBookmark.isDefault = true;
            }
            // set data
            return {
                ...state,
                allBookmarks: bookmarksCopy,
            };
        }

        case types.SET_ACTIVE_BOOKMARK: {
            return {
                ...state,
                activeBookmark: action.data,
            };
        }

        case types.SET_LOADING_BOOKMARKS: {
            return {
                ...state,
                loadingBookmarks: action.data,
            };
        }

        case types.SET_FOUND_BOOKMARKS: {
            return {
                ...state,
                foundBookmarks: action.data,
            };
        }

        case types.SET_SHOW_BOOKMARK_MODAL: {
            return {
                ...state,
                showBookmarkModal: action.data,
            };
        }

        default:
            return state;
    }
};
